import React, { useState } from 'react';
import { FaUsers } from 'react-icons/fa';
import {
  BoardGrid,
  BoardMember,
  LearnMoreButton,
  ModalOverlay,
  ModalContent,
  CloseButton,
  BoardGridContainer,
} from './Leadership.styles';

import { SectionContentWrapper, GlassContainer, WhiteCard } from '../About.styles';

const boardMembers = [
  {
    name: 'Ngozika Orjioke, MD, FCCP',
    title: 'Board Chair',
    imgSrc: 'images/Ngozika_Orjioke.PNG',
    description: `Dr. Ngozika Orjioke is a Board-Certified Physician in Internal Medicine, Pulmonary, and Critical Care Medicine, with extensive experience in clinical practice, healthcare administration, and policy. Her global travels have enriched her understanding of diverse cultures, enabling her to deliver culturally sensitive care to her patients.
Committed to making a lasting impact on healthcare delivery, Dr. Orjioke pursued an MBA with a focus on Management Technology. As a skilled administrator, she has experience in healthcare start-ups and revitalizing distressed hospitals. Currently, she operates her own practice, Covenant Pulmonary and Critical Care Inc., in Atlanta, where she provides both outpatient and inpatient services to local and international patients. She is particularly passionate about delivering compassionate care to critically ill patients and providing support for end-of-life care. She is also a blessed mother of five and a grandmother of two children.`,
  },
  {
    name: 'Nathan Streer, MD',
    title: 'Vice Board Chair',
    imgSrc: 'images/nathan.png',
    description: `Dr. Streer is a board certified Medical Oncologist at Veterans Affairs Healthcare System, specializing in comprehensive cancer care for veterans. He previously served as the Director of Palliative Care at the Comprehensive Cancer Center at Wake Forest University Medical Center, where he developed innovative programs to improve the quality of life for patients with serious illnesses.
Passionate about enhancing medical care through education, Dr. Streer advocates for patient-centered approaches in oncology and palliative care. He believes that empowering healthcare providers with effective education is essential for delivering empathetic, high-quality care tailored to individual patient needs. Dr. Streer aims to inspire the next generation of medical professionals to prioritize holistic and patient-focused care.`,
  },
  {
    name: 'Beza Kassahun Awgichew',
    title: 'Secretary',
    imgSrc: 'images/beza_black.png',
    description: `Beza Kassahun Awgichew is an aspiring counselor with a Bachelor's degree in Sociology and Social Anthropology. She has broadened her expertise through courses in International Relations and Theology, as well as programs in Early Childhood Education and Human Resources. Currently, Beza is pursuing a master’s degree with dual licensure in Clinical Mental Health Counseling and Alcohol and Drug Counseling.
As a mother of twins, Beza is dedicated to cultivating a teachable spirit, promoting holistic growth, and inspiring others to do the same, all while placing God at the center of her endeavors. She brings a unique blend of skills, including active listening, empathy, and cross-cultural communication, which she has honed through her academic background and counseling experience.`,
  },
  {
    name: 'Hiwot Abebe Mengiste, MD',
    title: 'Treasurer',
    imgSrc: 'images/leader-002.png',
    description: `Dr. Hiwot Mengiste is a board-certified internal medicine, pulmonary and critical care physician dedicated to providing compassionate, patient-centered care. She has a deep passion for supporting patients and their families through some of life’s most challenging moments, particularly in making end-of-life decisions and ensuring dignity in care.
She is currently practicing as an attending physician at Sentara Williamsburg Hospital in Virginia, where she is committed to enhancing patient outcomes through expert clinical care and empathetic guidance.
Beyond medicine, Dr. Mengiste treasures time with her family. She and her supportive partner are raising two wonderful boys and a girl who bring energy, purpose, and joy to her life. She values meaningful relationships with loved ones and strives to make a positive impact in her community.`,
  },
  {
    name: 'Daniel Digafie, MD',
    title: 'Regional Coordinator',
    imgSrc: 'images/Daniel_Digafie.png',
    description: `Daniel Digafie is a dedicated medical doctor with master’s degrees in General Public Health and Business Administration. Currently studying Regional and Local Development Analysis and Planning at Addis Ababa University. As the co-founder and executive director of Bego Sitota, a local charity focused on enhancing education and healthcare in Ethiopia, Daniel has over five years of experience leading initiatives that provide college sponsorship for economically disadvantaged students, offer tutoring support, establish digital libraries, and empower single mothers through sustainable career programs. A passionate leader and innovator, Daniel drives meaningful change by leveraging his expertise in project management, healthcare systems, and community development.`,
  },
];

const Leadership: React.FC = () => {
  const [selectedMember, setSelectedMember] = useState<number | null>(null);

  const openModal = (index: number) => setSelectedMember(index);
  const closeModal = () => setSelectedMember(null);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      <GlassContainer>
        <WhiteCard>
          <SectionContentWrapper>
            <h2>
              <FaUsers style={{ marginRight: '0.5rem', color: '#039BE5' }} />
              Our Leadership
            </h2>
            <p>
              Guided by a passionate and dedicated team, our leadership embodies diverse expertise and unwavering commitment. Each board member brings their own perspective, professional experience, and wholehearted dedication to expanding Hope Beyond International’s reach and impact.
            </p>

            <BoardGridContainer>
              <BoardGrid style={{ justifyContent: 'center' }}>
                {boardMembers.map((member, index) => (
                  <BoardMember key={index}>
                    <img src={member.imgSrc} alt={member.name} />
                    <h4>{member.name}</h4>
                    <p>{member.title}</p>
                    {member.description && (
                      <>
                        <p className="description">
                          {`${member.description.substring(0, 100)}...`}
                        </p>
                        <LearnMoreButton onClick={() => openModal(index)}>
                          Learn More
                        </LearnMoreButton>
                      </>
                    )}
                  </BoardMember>
                ))}
              </BoardGrid>
            </BoardGridContainer>
          </SectionContentWrapper>
        </WhiteCard>
      </GlassContainer>

      {/* Modal for Full Descriptions */}
      {selectedMember !== null && (
        <ModalOverlay onClick={handleOverlayClick}>
          <ModalContent>
            <CloseButton onClick={closeModal}>×</CloseButton>
            <img src={boardMembers[selectedMember].imgSrc} alt={boardMembers[selectedMember].name} />
            <h3>{boardMembers[selectedMember].name}</h3>
            <h4>{boardMembers[selectedMember].title}</h4>
            <p>{boardMembers[selectedMember].description}</p>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default Leadership;
